import React from "react";

function Footer() {
  const services = [
    "سداد قروض صبيا",
    "مكتب سداد أبو عريش",
    "مكتب صبيا وتسديد القروض",
    "تسديد متعثرات سمة",
    "رفع الاسم من سمة وتحديث سمة",
    "فك إيقاف الخدمات وناجز",
    "تحويل الراتب من بنك لآخر",
    "استخراج قرض جديد حتى 36 راتب",
    "قرض عقاري + وحدة سكنية جاهزة",
    "سداد قروض المدنيين والعسكريين",
    "سداد قروض القطاع الخاص",
    "سداد قروض الراجحي والأهلي والرياض",
    "سداد قروض الإنماء والبلاد والجزيرة",
    "جدولة المديونية وتوحيد الالتزامات",
    "مخالصة بنكية وسداد مبكر",
    "استخراج من بنك التنمية (التسليف)",
    "سداد قروض بيش وصامطة وأحد المسارحة",
    "سداد قروض ضمد وفيفا وفرسان",
  ];

  return (
    <footer className="site-footer text-dark pt-5" id="services" dir="rtl">
      <div className="container">
        <div className="row g-4 justify-content-between">
          <section
            className="col-12 col-lg-7 text-center text-lg-end"
            aria-labelledby="footer-services-heading"
          >
            <h2
              id="footer-services-heading"
              className="fw-bold h4 text-primary mb-3"
            >
              خدمات مكتب صبيا وأبو عريش وجازان
            </h2>
            <p className="text-muted mb-4 lead fs-6">
              سداد قروض صبيا، مكتب سداد أبو عريش، وحلول تسديد المتعثرات لعملاء
              منطقة جازان عبر البنوك المحلية:
            </p>

            <ul className="row g-2 text-end list-unstyled mb-0">
              {services.map((service) => (
                <li key={service} className="col-12 col-md-6">
                  <div className="service-item">
                    <i
                      className="fas fa-check-circle text-primary small"
                      aria-hidden="true"
                    ></i>
                    <span className="small fw-medium text-secondary">
                      {service}
                    </span>
                  </div>
                </li>
              ))}
            </ul>
          </section>

          <div className="col-12 col-md-6 col-lg-4 d-flex flex-column justify-content-start gap-4 text-center text-md-end">
            <section aria-labelledby="footer-contact-heading">
              <h2
                id="footer-contact-heading"
                className="fw-bold h5 text-dark mb-3"
              >
                تواصل معنا الآن
              </h2>
              <address className="mb-0 fst-normal">
                <p className="mb-2 text-muted">
                  <i
                    className="fas fa-map-marker-alt text-primary ms-2"
                    aria-hidden="true"
                  ></i>
                  <span>
                    صبيا · أبو عريش · جازان، المملكة العربية السعودية
                  </span>
                </p>
                <p className="mb-0">
                  <a
                    href="tel:+966530179640"
                    className="text-decoration-none text-dark fw-bold d-inline-flex align-items-center"
                  >
                    <i
                      className="fas fa-phone-alt text-success ms-2"
                      aria-hidden="true"
                    ></i>
                    <span dir="ltr">+966530179640</span>
                  </a>
                </p>
              </address>
            </section>

            <nav aria-labelledby="footer-social-heading">
              <h2
                id="footer-social-heading"
                className="fw-bold h6 text-dark mb-2"
              >
                تابعنا عبر السناب شات
              </h2>
              <ul className="d-flex gap-2 justify-content-center justify-content-md-start list-unstyled mb-0">
                <li>
                  <a
                    href="https://www.snapchat.com/add/user011829787?share_id=7UWSAERe7m4&locale=ar-SA"
                    className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                    style={{
                      width: "42px",
                      height: "42px",
                      backgroundColor: "#FFFC00",
                      border: "none",
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="حساب سناب شات"
                  >
                    <i
                      className="fab fa-snapchat-ghost text-dark fs-5"
                      aria-hidden="true"
                    ></i>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        <hr className="my-4 text-muted opacity-25" />

        <aside className="legal-note p-3 text-center mb-4" aria-label="تنويه قانوني">
          <p className="text-muted small mb-0 lh-lg">
            <strong className="text-dark">
              <i
                className="fas fa-exclamation-circle ms-1 text-warning"
                aria-hidden="true"
              ></i>{" "}
              تنويه قانوني:
            </strong>{" "}
            نحن جهة مساعدة في سداد القروض والتعثرات البنكية، ولسنا جهة تمويل أو
            ممثلين لأي بنك أو مؤسسة مالية. جميع الخدمات تخضع للشروط والأنظمة
            المعمول بها في المملكة العربية السعودية.
          </p>
        </aside>

        <div className="py-3 text-center text-muted small d-flex flex-column flex-md-row justify-content-between align-items-center gap-2">
          <p className="mb-0">
            <small>
              © {new Date().getFullYear()} سداد قروض صبيا وأبو عريش وجازان.
              جميع الحقوق محفوظة.
            </small>
          </p>
          <p className="mb-0">
            <small>
              الشركة التقنية المطوّرة:{" "}
              <a
                href="https://quantumsw.tech"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary fw-bold text-decoration-none"
              >
                كوانتم سوفتوير — Quantum Software
              </a>
            </small>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
